import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './jump-links.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';

const jumpLinksConverter = {
    fromAttribute: (value) => {
        if (!value)
            return [];
        try {
            const parsedValue = JSON.parse(value);
            return parsedValue
                .map(item => ({
                label: item.label || item.Label || '',
                href: item.href || item.Href || '',
            }))
                .filter(item => item.label.length > 0 && item.href.length > 0);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error parsing jump links:', error, 'Value:', value);
            return [];
        }
    },
    toAttribute: (value) => JSON.stringify(value),
};
class JumpLinks extends s {
    constructor() {
        super(...arguments);
        this.ariaLabel = 'Jump links';
        this.links = [];
        this.jumpToLabel = 'Jump to:';
        this.rtl = false;
    }
    getHashFromHref(href) {
        if (!href)
            return '';
        if (href.startsWith('#'))
            return href;
        const normalizedHref = href.startsWith('/')
            ? `${globalThis.location.origin}${href}`
            : href;
        const targetUrl = new URL(normalizedHref, globalThis.location.href);
        const samePage = targetUrl.origin === globalThis.location.origin &&
            targetUrl.pathname === globalThis.location.pathname;
        return samePage ? targetUrl.hash : '';
    }
    getScrollOffset() {
        const hostStyles = globalThis.getComputedStyle(this);
        const scrollOffset = hostStyles
            .getPropertyValue('--jump-links-scroll-offset')
            .trim();
        if (!scrollOffset)
            return 0;
        const parsedOffset = Number.parseInt(scrollOffset, 10);
        return Number.isNaN(parsedOffset) ? 0 : parsedOffset;
    }
    navigateToHash(hash) {
        const targetId = decodeURIComponent(hash.replace('#', ''));
        if (!targetId)
            return;
        const targetElement = globalThis.document.getElementById(targetId);
        if (!targetElement)
            return;
        const targetPosition = targetElement.getBoundingClientRect().top +
            globalThis.scrollY -
            this.getScrollOffset();
        globalThis.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
        });
        globalThis.history.pushState(null, '', hash);
    }
    onLinkClick(event, href) {
        const hash = this.getHashFromHref(href);
        if (!hash)
            return;
        event.preventDefault();
        this.navigateToHash(hash);
    }
    renderLink(item) {
        return $ `<li class="jump-links__item"><generic-button-updated class="jump-links__button" type="tertiary" color="purple" styleType="light" .label="${item.label}" href="${item.href}" @click="${(event) => this.onLinkClick(event, item.href)}" ?rtl="${this.rtl || isRTL()}"></generic-button-updated></li>`;
    }
    render() {
        return $ `<nav class="jump-links" aria-label="${this.ariaLabel}" dir="${this.rtl || isRTL() ? 'rtl' : 'ltr'}"><div class="jump-links__container"><p class="jump-links__label">${this.jumpToLabel}</p><ul class="jump-links__list">${this.links.map(link => this.renderLink(link))}</ul></div></nav>`;
    }
}
JumpLinks.styles = css_248z;
__decorate([
    e({ type: String, attribute: 'aria-label' })
], JumpLinks.prototype, "ariaLabel", void 0);
__decorate([
    e({ attribute: 'links', converter: jumpLinksConverter })
], JumpLinks.prototype, "links", void 0);
__decorate([
    e({ type: String, attribute: 'jump-to-label' })
], JumpLinks.prototype, "jumpToLabel", void 0);
__decorate([
    e({ type: Boolean })
], JumpLinks.prototype, "rtl", void 0);
customElements.define('jump-links', JumpLinks);

export { JumpLinks };
